import { render } from "./DatastoreCatalogue.vue?vue&type=template&id=1f258370&scoped=true"
import script from "./DatastoreCatalogue.vue?vue&type=script&lang=js"
export * from "./DatastoreCatalogue.vue?vue&type=script&lang=js"

import "./DatastoreCatalogue.vue?vue&type=style&index=0&id=1f258370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f258370"]])

export default __exports__